import { useContext } from 'react';

import { BP42Ctx } from '~/src/packages/bp42/BP42Context';

const useIncomingCallbacks = () => {
    const { callbacks } = useContext(BP42Ctx);
    return callbacks;
};

export default useIncomingCallbacks;
